import React, { useState } from "react";

import UserReviews from "./UserReviews";
import UserGallery from "./UserGallery";
import UserDescription from "./UserDescription";
import UserCertifications from "./UserCertifications";

import { Typography, Grid, Stack } from "@mui/material";

const UserTab = ({ info, reviews }) => {
  const [value, setValue] = React.useState("");

  return (
    <Grid container>
      <Grid item sm={2}>
        <Stack spacing={2}>
          <Typography
            onClick={() => setValue("about")}
            style={{ cursor: "pointer" }}
          >
            About
          </Typography>
          <Typography
            onClick={() => setValue("skills")}
            style={{ cursor: "pointer" }}
          >
            Skills
          </Typography>

          {reviews.length ? (
            <Typography
              onClick={() => setValue("reviews")}
              style={{ cursor: "pointer" }}
            >
              Reviews
            </Typography>
          ) : (
            <></>
          )}

          <Typography
            onClick={() => setValue("certificates")}
            style={{ cursor: "pointer" }}
          >
            Certificates
          </Typography>
          <Typography
            onClick={() => setValue("gallery")}
            style={{ cursor: "pointer" }}
          >
            Gallery
          </Typography>
        </Stack>
      </Grid>
      <Grid item sm={9}>
        <UserDescription
          currentValue={value}
          desc={info.personalInfo.description}
          userSkills={info.expertise.skills}
        />
        <UserReviews currentValue={value} userReviews={reviews} />
        <UserCertifications
          currentValue={value}
          certificates={info.documents.certificationImages}
        />
        <UserGallery
          currentValue={value}
          galleryPics={info.personalInfo.image}
        />
      </Grid>
    </Grid>
  );
};

export default UserTab;
